/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { byKeys, findBy } from '@linc-technologies/linced-common/utils/arrays';
import moment from 'moment';

export default class GroupCard extends Component {
  @tracked type = 'from';
  processing = false;

  get cardClass() {
    return `class-placements-group class-placements-${this.type}`;
  }

  @computed('learners', 'type')
  get boundLearners() {
    let learners = this.learners.slice();
    learners.classPlacementsType = this.type;
    learners.group = this.group;
    if (this.type === 'from' && learners.length > 0) {
      learners.unshift('move-all');
    }
    return learners;
  }

  onLearnerDropped() {}
  onGroupSaved() {}

  @action
  learnerDropped({ draggedItem, sourceList, targetList }) {
    if (targetList.classPlacementsType === 'from') {
      // Ignore drops onto "from" groups.
      return;
    }

    let members = [draggedItem];
    if (draggedItem === 'move-all') {
      members = sourceList.slice(1); // Remove the "move-all" item from the list.
    }

    let targetGroup = targetList.group;
    let sourceGroup = sourceList.group;

    // Notify the consuming component that we're working with these groups.
    this.onLearnerDropped(sourceGroup.id, targetGroup.id);
    members.forEach((member) => {
      let existing = findBy(targetGroup.learners, 'personId', member.personId);
      if (isEmpty(existing)) {
        // Not in this group.  Add a new Member fragment.
        targetGroup.learners.createFragment({
          personId: member.personId,
          status: member.status,
        });
      } else {
        // Already in this group, presumably with a different status (i.e. not current).
        existing.set('status', member.status);
      }
    });

    // If dragged between toGroups, remove them from the old one (assuming it's not the current calendar year).
    // This is done outside the loop, as only individual students can be dragged from toGroups.
    // TODO: Remove this (and update model.toGroups) when groups service auto-updates non-current-year homerooms.
    if (
      sourceList.classPlacementsType === 'to' &&
      sourceList.group.year !== moment().year()
    ) {
      let toRemove = findBy(
        sourceGroup.learners,
        'personId',
        draggedItem.personId,
      );
      if (!isEmpty(toRemove)) {
        toRemove.set('status', 2); // 2 = Former
        sourceGroup.save(); // Don't need to wait, as it will update automatically when resolved.
      }
    }

    targetGroup
      .save()
      .then(() => {
        this.onGroupSaved(sourceGroup.id, targetGroup.id);
      })
      .catch(() => {
        sourceGroup.rollbackAttributes();
      });
  }

  @action
  determinePosition({ draggedItem, items }) {
    // addObject only appends when the item is absent.
    let ordered = items.includes(draggedItem)
      ? [...items]
      : [...items, draggedItem];
    return ordered.sort(byKeys('person.fullName')).indexOf(draggedItem);
  }
}
